<template>
    <div class="profile-data">
        <div class="d-flex justify-content-center p-5" v-if="loading">
            <app-loading  />
        </div>
        <div v-else class="box-authentication2 fix">
            <table class="table table-responsive table-bordered">
                <thead>
                    <tr>
                        <th width="12%">Product</th>
                        <th width="38%">Name</th>
                        <th width="15%">Qty</th>
                        <th width="20%">Price</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="text-center" v-for="cart in carts">
                        <td>
                            <img :src="productImage(cart)"
                                 style="width:50px;height:50px;">
                        </td>
                        <td>{{ cart.name }}</td>
                        <td>{{ cart.quantity }}</td>
                        <td>&#2547; {{ Number(subtotalWithDiscount(cart)).toFixed(2) }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="calculateTotal fix">
                <ul class="list-group" style="float: right;width:250px">
                    <li class="list-group-item">Subtotal : <span
                            style="float: right;">  &#2547; {{ Number(total_price).toFixed(2) }} </span></li>
                    <li class="list-group-item">Shipping Charge : <span
                            style="float: right;"> &#2547; 30 </span></li>
                    <li class="list-group-item">Total Amount: <span
                            style="float: right;">&#2547; {{ Number(Number(total_price) + 30).toFixed(2) }} </span></li>
                </ul>
            </div>

            <div class="extra-login text-center">
                <span>Select Payment Method</span>
            </div>
            <div class="payment-checkbox">
                <div class="position-relative form-group">
                    <div>
                        <div class="custom-radio custom-control">
                            <input type="radio"
                                   id="cod"
                                   name="payment_type"
                                   class="custom-control-input"
                                   value="cash_on_delivery"
                                   v-model="formData.payment_method"
                            />
                            <label class="custom-control-label" for="cod">
                                Cash On Delivery
                            </label>
                        </div>
                        <!--<div class="custom-radio custom-control">
                            <input type="radio"
                                   id="onl"
                                   name="payment_type"
                                   class="custom-control-input"
                                   value="online_payment"
                                   v-model="formData.payment_method"
                            />
                            <label class="custom-control-label" for="onl">Online Payment</label>
                        </div>-->
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="position-relative form-group">
                    <label class="">Delivery note</label>
                    <textarea rows="2"
                              class="form-control"
                              placeholder="Delivery note"
                              v-model="formData.notes"></textarea>
                    <span class="text-danger">
                            {{ $errorMessage(errors, 'notes') }}
                        </span>
                </div>
            </div>
        </div>
        <div class="place-order">
            <button class="btn btn-danger btn-block btn-lg"
                    type="submit"
                    :disabled="loading"
                    @click="placeOrder">
                <i class="fa fa-shopping-cart"></i> Place Order
            </button>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapState} from "vuex";
    import {optional} from "../app/Helpers/Helpers";

    export default {
        name: "OrderDetails",
        data() {
            return {
                formData: {
                    payment_method: 'cash_on_delivery'
                }
            }
        },
        methods: {
            async placeOrder() {
                await this.$store.dispatch('placeOrder', this.formData);
            }
        },
        computed: {
            ...mapState({
                carts: state => state.cart.carts,
                loading: state => state.loading,
                isLoggedIn: state => state.isLoggedIn,
                errors: state => state.errors,
                response: state => state.response,
                success: state => state.success,
            }),
            ...mapGetters({
                total_price: 'total_price',
                total_quantity: 'totalQuantity',
            }),
            productImage() {
                return (cart) => {
                    return Boolean(optional(cart, 'image', 'path')) ?
                        optional(cart, 'image', 'path') :
                        '/images/no_image.jpg';
                }
            },
            subtotal() {
                return (cart) => {
                    return Number(cart.quantity) * Number(cart.sell_price);
                }
            },
            subtotalWithDiscount() {
                return (cart) => {
                    if (!Number(cart.default_discount)) {
                        return this.subtotal(cart);
                    }

                    return this.subtotal(cart) - (Number(cart.default_discount) * Number(cart.quantity));
                }
            }
        },
        watch: {
            success: function (value) {
                if (Boolean(value) && Boolean(this.response?.order_number)) {
                    this.$toastr.s(this.response.message);
                    setTimeout(() => {
                        window.location = this.response.url;
                    }, 500)
                }
            }
        }
    }
</script>

<style scoped>

</style>